import { createFileRoute } from '@tanstack/react-router';

import { ChannelsPage } from '@/features/attribution/pages/channels';

export const Route = createFileRoute('/_app/settings/channels')({
  component: ChannelsPage,
});
